import { render } from "./CargoItemRegistryForm.vue?vue&type=template&id=5486d020&scoped=true"
import script from "./CargoItemRegistryForm.vue?vue&type=script&lang=js"
export * from "./CargoItemRegistryForm.vue?vue&type=script&lang=js"

import "./CargoItemRegistryForm.vue?vue&type=style&index=0&id=5486d020&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5486d020"]])

export default __exports__